import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { CustomEvent, CustomEventPermission, MergedCustomEvent, Project } from '../types';

export type CustomEventsQueryContextState = {
  customEvents: MergedCustomEvent[];
  eventsByName: Record<string, CustomEvent>;
  isErrorCustomEvents: boolean;
  isLoadingCustomEvents: boolean;
  project: Project;
  refetchCustomEventMappings: () => void;
  refetchProject: () => void;
  allowNewCustomEvents?: boolean;
  customEventPermissions: CustomEventPermission[];
  isLoadingProjectSettings: boolean;
};

const defaultState = {
  customEvents: [],
  eventsByName: {},
  isErrorCustomEvents: false,
  isLoadingCustomEvents: false,
  project: {} as Project,
  refetchCustomEventMappings: noop,
  refetchProject: noop,
  allowNewCustomEvents: undefined,
  customEventPermissions: [],
  isLoadingProjectSettings: false,
};

export const CustomEventsQueryContext = createContext<CustomEventsQueryContextState>(defaultState);

export const useCustomEventsQueryContext = () => {
  const context = useContext(CustomEventsQueryContext);

  if (context === undefined) {
    throw new Error('useCustomEventsQueryContext must be used within a provider');
  }

  return context;
};
